import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { parkCityUTConfig } from "./data";

export default function ParkCityUTPage() {
  return <CityPageTemplate config={parkCityUTConfig} />;
}